var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#CDCCCC;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#FFD881;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,183.34c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,149.04,62.94,183.34,105.63,183.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.68,107.28c0.47,0,0.94,0.12,1.37,0.37l16.11,9.46c1.29,0.76,1.72,2.42,0.96,3.71 c-0.76,1.29-2.42,1.72-3.71,0.96l-16.11-9.46c-1.29-0.76-1.72-2.42-0.96-3.71C54.85,107.76,55.75,107.28,56.68,107.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.35,107.28h16.46c1.5,0,2.71,1.21,2.71,2.71c0,1.5-1.21,2.71-2.71,2.71H49.35c-1.5,0-2.71-1.21-2.71-2.71 C46.65,108.49,47.86,107.28,49.35,107.28z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.32,122.09L58.32,122.09c0-15.49,15.19-26.42,29.88-21.5l41.54,13.92c6.33,2.12,10.59,8.05,10.59,14.72v0 c0,8.58-6.95,15.53-15.53,15.53H80.99C68.47,144.76,58.32,134.61,58.32,122.09z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.98,86.2h-18.55c-1.5,0-2.71-1.21-2.71-2.71s1.21-2.71,2.71-2.71h16.78l5.83-13.4 c0.6-1.37,2.19-2,3.56-1.4c1.37,0.6,2,2.19,1.4,3.56l-6.54,15.03C147.03,85.56,146.05,86.2,144.98,86.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.2,113.25c-1.5,0-2.71-1.21-2.71-2.71V86.28c0-1.5,1.21-2.71,2.71-2.71c1.5,0,2.71,1.21,2.71,2.71v24.27 C81.91,112.04,80.7,113.25,79.2,113.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.78,122.15c-0.28,0-0.56-0.04-0.83-0.13c-1.42-0.46-2.2-1.99-1.74-3.41l11.2-34.57 c0.46-1.42,1.99-2.2,3.41-1.74c1.42,0.46,2.2,1.99,1.74,3.41l-11.2,34.57C129.98,121.42,128.92,122.15,127.78,122.15z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 79.2,
    cy: 122.08,
    r: 9.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.76,82.45L68.76,82.45c0-3.95,3.87-6.73,7.61-5.47l10.58,3.54c1.61,0.54,2.7,2.05,2.7,3.75v0 c0,2.18-1.77,3.95-3.95,3.95H74.53C71.34,88.22,68.76,85.64,68.76,82.45z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 126.28,
    cy: 128.9,
    r: 5.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.31,136.34c-0.47,0-0.94-0.12-1.37-0.37l-16.11-9.46c-1.29-0.76-1.72-2.42-0.96-3.71 c0.76-1.29,2.42-1.72,3.71-0.96l16.11,9.46c1.29,0.76,1.72,2.42,0.96,3.71C97.14,135.86,96.24,136.34,95.31,136.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.64,136.33H86.18c-1.5,0-2.71-1.21-2.71-2.71c0-1.5,1.21-2.71,2.71-2.71h16.46 c1.5,0,2.71,1.21,2.71,2.71C105.35,135.12,104.13,136.33,102.64,136.33z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.97,92.3c0,0.03-0.02,0.06-0.06,0.06l0,0H99.8c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06h0.11 C99.94,92.24,99.97,92.26,99.97,92.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinning);
export default __webpack_public_path__ + "static/media/Spinning.18dc789526b94a19e69c970591f6be5c.svg";
export { ForwardRef as ReactComponent };